import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface CategoriesTableProps {
}

export const CategoriesTable: React.FC<CategoriesTableProps> = () => {

    const categoriesState = useAppSelector(state => state.categories);

    return (
        <>
            <table className="data">
                <thead>
                <tr>
                    <th>Nimi</th>
                    <th className="right w150"></th>
                </tr>
                </thead>
                <tbody>
                {categoriesState.categories.map(row => {
                    return (
                        <tr key={row.id}>
                            <td>
                                {row.name}
                            </td>
                            <td className="action">
                                <Link to={`/categories/${row.id}/modify`}>Muuda</Link>
                                <span>|</span>
                                <Link to={`/categories/${row.id}/delete`}>Kustuta</Link>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <ul className="table-actions">
                <li>
                    <Link to="/categories/new">
                        <strong>Lisa kategooria</strong>
                    </Link>
                </li>
            </ul>
        </>
    );

}